<nav class="mobile-header fixed top-0 left-0 right-0 lg:hidden">
  <div class="container">
    <ul class="my-0 flex h-[56px] list-none items-center justify-start">
      <li class="w-8 grow-0">
        <button
          class="nav-toggle focus-link"
          aria-label="Toggle menu here"
          (click)="openSideNav()"
          [attr.aria-hidden]="isSideNavOpen">
          <span class="hamburger-menu-bar">
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>
      </li>
      <li class="mr-8 flex-1 text-center">
        <a
          [routerLink]="['/']"
          [attr.aria-hidden]="isSideNavOpen"
          class="focus-link">
          <img
            alt="Star Alliance logo"
            class="w-[195px]"
            [src]="'logo-star_alliance.svg' | rdAssetPath: AssetType.Image" />
        </a>
      </li>
      <li></li>
    </ul>
  </div>

  <mat-sidenav-container class="sidenav-container" [ngStyle]="style()">
    <mat-sidenav
      #sidenav
      position="start"
      mode="over"
      class="sidenav"
      (closedStart)="handleSideNavClose()"
      (openedStart)="handleSideNavOpen()">
      <star-core-side-nav
        [authRenderState]="authRenderState"
        (sideNavClose)="closeSideNav()"
        (userAction)="handleUserAction($event)">
      </star-core-side-nav>
    </mat-sidenav>
  </mat-sidenav-container>
</nav>
